export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game'],
        self: true
    },
    lang: {
        name: 'Has Inventory Location',
        category: ['User', 'Collection'],
        description: 'Whether user has provided inventory location or not.',
        summarise: {
            template: {
                yes: 'User has provided an inventory location',
                no: 'User has not provided an inventory location'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['inventory.location.exists']
    }
}